module.exports = __webpack_public_path__ + "img/topHeader.62f91241.png";